import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { ConfigEntryType } from 'config/config';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

type HasAttachmentsFilterFieldProps = {
  filter: ConfigEntryType;
};

function HasAttachmentsFilterField({ filter }: HasAttachmentsFilterFieldProps) {
  const {
    control,
    formState: { isSubmitting },
    setValue,
  } = useFormContext<Record<string, any>>();
  const selectedValues = useWatch({ control, name: filter.entryCode, defaultValue: [] });
  const value = selectedValues?.[0] === 'true' ? true : false;

  return (
    <Box sx={{ mt: -0.5 }}>
      <Controller
        control={control}
        render={({ field: radioField }) => (
          <Box>
            <FormControlLabel
              {...radioField}
              control={
                <Checkbox
                  checked={value}
                  size="small"
                  onChange={(e) => {
                    setValue(filter.entryCode, e.target.checked ? ['true'] : [], {
                      shouldDirty: true,
                      shouldValidate: true,
                    });
                  }}
                />
              }
              label={filter?.entryDescription}
              disabled={isSubmitting}
            />
          </Box>
        )}
        name={filter.entryCode}
      />
    </Box>
  );
}

export default HasAttachmentsFilterField;
